type InitialsInput = string | null | undefined | { first?: string | null; last?: string | null };

export function getInitials(input: InitialsInput): string {
  const parts =
    typeof input === "string" || input === undefined || input === null
      ? (input ?? "").split(/\s+/).filter(Boolean).slice(0, 2)
      : [input.first, input.last].filter((part): part is string => !!part);
  return parts
    .map((p) => p[0] ?? "")
    .join("")
    .toUpperCase();
}
